// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8e9e3616","821":"80cd0387"}[chunkId] + ".chunk.js";
};